"use client";

import { generateHTML } from "@tiptap/html";
import { useState } from "react";
import { defaultTiptapExtensions } from "@/ui/admin/tiptap-extensions";
import { defaultContent } from "@/ui/admin/tiptap-utils";
import { ExpandableRichText } from "./expandable-rich-text";

export const ExpandableTabs = ({
	items,
	isBuilder,
}: {
	items: {
		title?: string | null;
		content?: unknown | null;
	}[];
	isBuilder: boolean;
}) => {
	const [activeTabIdx, setActiveTabIdx] = useState(0);

	const activeItem = items[activeTabIdx];

	return (
		<div className="w-full mx-auto">
			<div className="border-b border-neutral-200">
				<nav className="-mb-px flex space-x-8" aria-label="Tabs">
					{items.map((item, idx) => (
						<button
							type="button"
							key={idx}
							onClick={() => setActiveTabIdx(idx)}
							className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
								activeTabIdx === idx
									? "border-neutral-700 text-neutral-700"
									: "border-transparent text-neutral-500 hover:text-neutral-700 hover:border-neutral-300"
							}`}
							aria-current={activeTabIdx === idx ? "page" : undefined}
						>
							{item.title}
						</button>
					))}
				</nav>
			</div>

			<div className="">
				{activeItem && (
					<div className="prose prose-theme max-w-none! h-full *:h-full" data-yns-click>
						{isBuilder ? (
							<ExpandableRichText key={activeTabIdx} content={activeItem.content} idx={activeTabIdx} />
						) : (
							<div
								// biome-ignore lint/security/noDangerouslySetInnerHtml: html generated with tiptap is safe
								dangerouslySetInnerHTML={{
									__html: generateHTML(activeItem.content || defaultContent, defaultTiptapExtensions),
								}}
							/>
						)}
					</div>
				)}
			</div>
		</div>
	);
};
